<div class="tags-container">
  @for (item of items; track item) {
    <p-tag 
      [value]="item"
      [rounded]="true"
      styleClass="me-1 mb-1">
    </p-tag>
  }
</div>